module.exports = __webpack_public_path__ + "img/meeting-point.2f6812b7.svg";